import React from 'react';
import {
  Link,
} from '../../../coreui';

const AccredGTKYSubmitted = () => {
  return (
    <>
      {`
        Thank you for submitting the information required for full accredited investor access. You will receive a call from a member of our Investor Relations team as part of the final approval process. Once you are approved, you will be able to view our full suite of investment opportunities including private placements.
      `}
      <br /><br />
      To expedite this process, please
      call <Link type="L4" href="tel:14243255160">(424) 325-5160</Link> (M-F 8 am-6 pm PST).
    </>
  );
};

export default AccredGTKYSubmitted;
